// Shared formatting + presentation helpers for the MT5 command center.

export const fmtMoney = (value, currency = "EUR") => {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(n);
  } catch (_) {
    return `${n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
  }
};

export const fmtSigned = (value, currency = "EUR") => {
  const n = Number(value || 0);
  const sign = n >= 0 ? "+" : "−";
  return `${sign}${fmtMoney(Math.abs(n), currency)}`;
};

export const fmtPrice = (value) =>
  Number(value || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtPct = (value) => {
  const n = Number(value || 0);
  return `${n >= 0 ? "+" : ""}${n.toFixed(2).replace(".", ",")}%`;
};

export const timeShort = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  } catch (_) {
    return "—";
  }
};

export const timeHM = (iso) => {
  if (!iso) return "ora";
  try {
    return new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  } catch (_) {
    return "ora";
  }
};

export const sideColor = (side) => (String(side).toUpperCase() === "BUY" ? "text-emerald-400" : "text-rose-400");
